import React from 'react';
import { Layout, Menu } from 'antd';
import {
    BookOutlined,
    UserOutlined,
    QuestionOutlined,
    VideoCameraOutlined,
    RocketOutlined,
    FileOutlined,
    LinkOutlined
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const Sidebar: React.FC = () => {
    const location = useLocation();

    const menuItems = [
        {
            key: '/admin/exams',
            icon: <BookOutlined />,
            label: <Link to="/admin/exams">Quản Lý Đề Thi</Link>,
        },
        {
            key: '/admin/questions',
            icon: <QuestionOutlined />,
            label: <Link to="/admin/questions">Quản Lý Câu hỏi</Link>,
        },
        {
            key: '/admin/users',
            icon: <UserOutlined />,
            label: <Link to="/admin/users">Quản Lý Người Dùng</Link>,
        },
        {
            key: '/admin/videos',
            icon: <VideoCameraOutlined />,
            label: <Link to="/admin/videos">Quản Lý Video</Link>,
        },
        {
            key: '/admin/skills',
            icon: <RocketOutlined />,
            label: <Link to="/admin/skills">Quản Lý Kỹ Năng</Link>,
        },
        {
            key: '/admin/privacy',
            icon: <FileOutlined />,
            label: <Link to="/admin/privacy">Quản Lý Chính Sách</Link>,
        },
        {
            key: '/admin/link-document',
            icon: <LinkOutlined />,
            label: <Link to="/admin/link-document">Quản Lý Link Đề Thi</Link>,
        },
        {
            key: '/admin/courses',
            icon: <BookOutlined />,
            label: <Link to="/admin/courses">Quản Lý Khóa Học</Link>,
        },
        {
            key: '/admin/documents',
            icon: <FileOutlined />,
            label: <Link to="/admin/documents">Quản Lý Tài Liệu</Link>,
        },
    ];

    return (
        <Sider
            width={250}
            className="h-screen fixed left-0 top-0 bottom-0 bg-white shadow-md"
        >
            <div className="flex items-center justify-center py-4 mb-4">
                <img
                    src="/logo.png"
                    alt="Admin Logo"
                    className="h-12 w-auto"
                />
            </div>
            <Menu
                mode="inline"
                selectedKeys={[location.pathname]}
                items={menuItems}
                className="border-r-0"
            />
        </Sider>
    );
};

export default Sidebar;